import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  addDialogVisible: boolean
  editDialogVisible: boolean
  walkSettingsVisible: boolean
}

const initialState: State = {
  addDialogVisible: false,
  editDialogVisible: false,
  walkSettingsVisible: false,
}

type TogglePayload = {
  open?: boolean
}

function toggled(current: boolean, payload: TogglePayload) {
  return payload.open ?? !current
}

export const bookmarksSlice = createSlice({
  name: 'bookmarks',
  initialState,
  reducers: {
    addDialogToggled(state, { payload }: PayloadAction<TogglePayload>) {
      state.addDialogVisible = toggled(state.addDialogVisible, payload)
    },
    editDialogToggled(state, { payload }: PayloadAction<TogglePayload>) {
      state.editDialogVisible = toggled(state.editDialogVisible, payload)
    },
    walkSettingsToggled(state, { payload }: PayloadAction<TogglePayload>) {
      state.walkSettingsVisible = toggled(state.walkSettingsVisible, payload)
    },
    dialogsClosed(state) {
      state.addDialogVisible = false
      state.editDialogVisible = false
      state.walkSettingsVisible = false
    },
  },
})
